import * as React from 'react';
import { connect } from 'react-redux';
import StyledWarningIcon from './WarningIcon.css';
/* Helpers */
const mapStateToProps = ({ api: { s3BasePath } }) => ({
  s3BasePath
});

/* Components */
const WarningIcon: React.FunctionComponent<{ s3BasePath: string }> = ({ s3BasePath }) => (
  <StyledWarningIcon src={`${s3BasePath}misc/warning-symbol.jpg`} />
);

export default connect(mapStateToProps)(WarningIcon);
